import { format } from 'date-fns'
import { getUSADefault } from '../Wizard2/selectOptions'

export const SET_CORRESPONDENCE2_REDUCER = 'SET_CORRESPONDENCE2_REDUCER'
export const SET_CORRESPONDENCE_RECIPIENT = 'SET_CORRESPONDENCE_RECIPIENT'
export const SET_CORRESPONDENCE_SEARCH_ITEM = 'SET_CORRESPONDENCE_SEARCH_ITEM'
export const SET_CORRESPONDENCE_WORKVIEW_ITEM = 'SET_CORRESPONDENCE_WORKVIEW_ITEM'

export const initialState = {
  // { DTO CONTENT
  CustomCorrespondenceId: null,
  CustomCorrespondenceTypeId: 1,
  CustomCorrespondenceTypeName: 'Rejection',
  CustomCorrespondenceNumber: '(New)',
  SourceTypeId: null,
  SourceType: '',
  SourceId: null,
  RecordTypeId: null,
  RecordSubTypeId: null,
  FilingTypeId: null,
  RecordName: '',
  SourceNumber: '',
  ProcessingStatusTypeId: null,
  ProcessingStatusType: '',
  FilingDate: format(new Date(), 'MM/dd/yyyy HH:mm a'),
  ImageNum: '',
  // EnclosedAmount: null, // not using yet
  // ReceiptNumber: null, // not using yet
  CreatedDate: new Date(),
  CreatedByAppUserId: null,
  LastModifiedDate: new Date(),
  LastModifiedBy: null,
  LastModifiedByName: '',
  EntryTypeId: null,
  EntryType: '',
  IncludeOriginalImage: false,
  ImageGroupId: null,
  CustomCorrespondenceReasons: [
    // {
    // CustomCorrespondenceReasonId: null,
    // CustomCorrespondenceReasonTypeId: null,
    // LongDescription: '',
    // ParamList: [],
    // Params: '',
    // }
  ],
  CustomCorrespondenceRecipient: {
    Address1: '',
    Address2: '',
    Address3: '',
    City: '',
    State: '',
    Country: getUSADefault(),
    PostalCode: '',
    Email: '',
    Name: '',
    // TO: '', // This is not part of the DTO, so why use it?
  },
  // } END DTO CONTENT

  ImageDataType: '',
  folded: false,
  loading: false,
  receiptInfo: {},
  rejectionsRequireRefunds: false,
  workviewItem: null,
  searchItem: null,
  readOnly: false,

  // FILING INFO STEP
  RecordType: '',
  RecordSubType: '',
  FilingType: '',
  sourceTypes: [],
  recordTypes: [],
  recordSubTypes: [],
  recordSubTypesXref: [],
  filingTypes: [],
  MiscellaneousModuleId: null,
  miscellaneousModules: [],
  showFilingSpinner: false,

  // CONTACT INFO STEP
  isEmail: false,
  isSnailMail: false,

  // REASON STEP
  generalReasons: [],
  specificReasons: [],
}

const Correspondence2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CORRESPONDENCE2_REDUCER: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case SET_CORRESPONDENCE_RECIPIENT: {
      return {
        ...state,
        CustomCorrespondenceRecipient: {
          ...state.CustomCorrespondenceRecipient,
          [action.accessor]: action.value,
        },
      }
    }
    case SET_CORRESPONDENCE_SEARCH_ITEM: {
      return {
        ...state,
        searchItem: action.row,
      }
    }
    case SET_CORRESPONDENCE_WORKVIEW_ITEM: {
      return {
        ...state,
        workviewItem: action.row,
      }
    }
    default:
      return state
  }
}

export default Correspondence2Reducer
